<template>
  <ul class="upgrade-tier-list">
    <li v-for="tier in tiers" class="upgrade-plan-item">
      <upgrade-plan v-bind="{tier, features, view, onSubmit}" />
    </li>
  </ul>
</template>
<script>

import UpgradePlan from 'brave-upgrade/components/plan'
import style from 'brave-upgrade/components/tier-list.scss'
export default {
  name: 'UpgradeTierList',
  components: {
    'upgrade-plan': UpgradePlan
  },
  props: ['features', 'tiers', 'view', 'onSubmit']
}
</script>